//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import { confirmationDialogFactory } from 'common/components/core/dialog/ConfirmationDialog';
import compose from 'recompose/compose';
import { translate } from 'react-i18next';

import theme from './MapBulkVerifyConfirmationDialog.scss';
import { dashboardColors } from 'common/enums/ColorEnum';

export const ConfirmationDialog = confirmationDialogFactory({});

class MapBulkVerifyConfirmationDialog extends React.PureComponent {
    render() {
        const {
            isVerified,
            onCancel,
            onAccept,
            type,
            theme,
            active,
            t
        } = this.props;

        const title = isVerified
            ? t('zoneMap.bulkUnverification')
            : t('zoneMap.bulkVerification');
        const acceptActionLabel = isVerified
            ? t('zoneMap.unverify')
            : t('zoneMap.verify');
        const innerText = t('zoneMap.bulkVerificationWarning', {
            type,
            status: isVerified
                ? t('zoneMap.verified')
                : t('zoneMap.unverified'),
            action: acceptActionLabel,
            targetStatus: isVerified
                ? t('zoneMap.unverified')
                : t('zoneMap.verified')
        });

        return (
            <ConfirmationDialog
                type={type}
                title={title}
                innerText={innerText}
                theme={theme}
                onAccept={onAccept}
                className={theme.bulkVerificationDialog}
                onCancel={onCancel}
                acceptActionLabel={acceptActionLabel}
                acceptActionColor={dashboardColors.coolGreen.name}
                active={active}
                isVerified={isVerified}
            />
        );
    }
}

const ThemedMapBulkVerifyConfirmationDialog = compose(
    themr('VerifyConfirmationDialog', theme),
    translate('entityManagement')
)(MapBulkVerifyConfirmationDialog);
export { ThemedMapBulkVerifyConfirmationDialog as MapBulkVerifyConfirmationDialog };
export default ThemedMapBulkVerifyConfirmationDialog;
